import { createReducer, on } from "@ngrx/store";
import { billActions } from "../bill.actions";
import { UploadedBill } from "../../../models/bill.model";

export interface BillUploadS3State {
    state: 'pending'|'loading'|'loaded'|'error'
}

export const initialState: BillUploadS3State = {
    state: 'pending'
};

export const billsUploadS3Reducer = createReducer(
    initialState,
    on(billActions.uploadBillsS3, (state) => ({
        ...state,
        state: 'loading' as const
    })),
    on(billActions.uploadBillsS3Success, (state) => ({
        ...state,
        state: 'loaded' as const
    })),
    on(billActions.uploadBillsS3Fail, (state) => ({
        ...state,
        state: 'error' as const
    })),
)